import type { LayoutElement } from '../types';
import { getElement3DExtrusionDepth, resolveEquipmentKitHeight } from './layout3d';
import { resolveStockerDimensions } from '../components/canvas/amhs/Stocker/stockerTypes';
import { resolveEquipmentLoadPortFoupSeatY } from '../components/canvas/amhs/Equipment/FabProcessTool/fabToolLayout';

/**
 * An OHT may remain pinned for a streamed PICKUP/DROP while its station is
 * unresolved, but lowering without a physical deck height would send the
 * gripper to the world floor and through the FOUP.
 */
export function canLowerOhtHoist(
  transferDurationS: number | null,
  transferDeckY: number | undefined
): boolean {
  return (
    transferDurationS !== null &&
    transferDurationS > 0 &&
    typeof transferDeckY === 'number' &&
    Number.isFinite(transferDeckY)
  );
}

/**
 * Load-port top the OHT hoist lowers to, in the station's own world frame.
 *
 * Both branches must use the height the renderer actually builds the station
 * at. Equipment is drawn at `resolveEquipmentKitHeight`, which floors short
 * footprints at the kit height — measuring the deck off the raw extrusion depth
 * instead sent the hoist below the load port on any tool shallower than the kit.
 */
export function resolveStationHandoffDeckY(
  element: Pick<LayoutElement, 'type' | 'dimensions' | 'position'> | null | undefined
): number | undefined {
  if (!element) return undefined;
  const extrusionDepth = getElement3DExtrusionDepth(element as LayoutElement);
  if (element.type === 'stocker') {
    const w = element.dimensions.width;
    const h = resolveEquipmentKitHeight(w, element.dimensions.height, extrusionDepth);
    return resolveStockerDimensions(w, h, extrusionDepth).foupSeatY;
  }
  const w = element.dimensions.width;
  const kitHeight = resolveEquipmentKitHeight(w, element.dimensions.height, extrusionDepth);
  return resolveEquipmentLoadPortFoupSeatY(w, kitHeight, extrusionDepth);
}
